import { PanelEditorScope } from "../panels/panel-editor-scope";
import { 
    PanelCladdingCellPropertiesDockingPanelContent,
} from "./content/panelCladdingCellPropertiesDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class PanelCladdingCellPropertiesDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement, panelEditorScope: PanelEditorScope) {
        this.visible = false;

        const component = <PanelCladdingCellPropertiesDockingPanelContent panelEditorScope={panelEditorScope} />;

        this.panel = new DockingPanel(
            container,
            "dextall-studio-panel-cladding-cell-properties",
            "Cladding Cell",
            component,
            {
                style: {
                    resize: "both",
                },
                dimensionsControl: {
                    preventOverlapsWithViewerToolbar: true,
                    widthDimensionControl: { value: 360, minValue: 360 },
                    heightDimensionControl: { value: 320, minValue: 320 },
                    topOffset: 2,
                    leftOffset: 364, // Positioned next to the Panel properties docking panel
                },
            },
        );
        this.panel.addVisibilityListener((x: boolean) => (this.visible = x));
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
